<template>
  <div class="be">
    <div class="be-header">
      <label class="be-toggle">
        <input type="checkbox" v-model="enabled" @change="onToggle" />
        <span class="be-toggle-label">Include call-to-action button</span>
      </label>
    </div>
    <div v-if="enabled" class="be-fields">
      <div class="be-field">
        <label class="be-label">Button text</label>
        <input
          class="be-input"
          :value="value.text"
          @input="update('text', $event.target.value)"
          placeholder="e.g. Learn More"
        />
      </div>
      <div class="be-field">
        <label class="be-label">Button URL</label>
        <input
          class="be-input"
          :value="value.url"
          @input="update('url', $event.target.value)"
          placeholder="https://..."
        />
      </div>
      <div class="be-field">
        <label class="be-label">Button color</label>
        <div class="be-colors">
          <button
            v-for="c in colors"
            :key="c"
            type="button"
            class="be-swatch"
            :class="{ 'be-swatch--active': value.color === c }"
            :style="{ background: c }"
            @click="update('color', c)"
          ></button>
        </div>
      </div>
      <!-- Preview -->
      <div v-if="value.text" class="be-preview">
        <span
          class="be-preview-btn"
          :style="{ background: value.color || colors[0] }"
        >{{ value.text }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ButtonEditor',

  props: {
    value: {
      type: Object,
      default: function () { return { text: '', url: '', color: '' }; },
    },
  },

  data() {
    return {
      enabled: !!(this.value && this.value.text),
    };
  },

  created: function () {
    if (this.value && !this.value.color) {
      this.update('color', this.brandPrimary);
    }
  },

  computed: {
    brandPrimary: function () {
      var style = getComputedStyle(document.documentElement);
      return (style.getPropertyValue('--primary-color') || '#3b86f5').trim();
    },
    brandDark: function () {
      var style = getComputedStyle(document.documentElement);
      return (style.getPropertyValue('--dark-color') || '#181818').trim();
    },
    colors: function () {
      return [this.brandPrimary, this.brandDark];
    },
  },

  methods: {
    update(field, val) {
      var updated = Object.assign({}, this.value);
      updated[field] = val;
      this.$emit('input', updated);
    },

    onToggle() {
      if (!this.enabled) {
        this.$emit('input', { text: '', url: '', color: this.value.color || '' });
      }
    },
  },

  watch: {
    value: {
      handler: function (v) {
        this.enabled = !!(v && v.text);
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.be {
  margin-bottom: 16px;
  border: 1px solid #e2e6ea;
  border-radius: 8px;
  padding: 12px 16px;
  background: #fafbfc;
}
.be-header {
  display: flex;
  align-items: center;
}
.be-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 13px;
  color: #5f6368;
  user-select: none;
}
.be-toggle input {
  accent-color: var(--primary-color, #3b86f5);
}
.be-toggle-label {
  font-weight: 500;
}
.be-fields {
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.be-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.be-label {
  font-size: 12px;
  font-weight: 600;
  color: #5f6368;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}
.be-input {
  height: 34px;
  padding: 0 10px;
  border: 1px solid #dadce0;
  border-radius: 6px;
  font-size: 13px;
  color: #181818;
  background: #fff;
  outline: none;
  transition: border-color 0.15s;
}
.be-input:focus {
  border-color: var(--primary-color, #3b86f5);
}
.be-colors {
  display: flex;
  gap: 6px;
}
.be-swatch {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 2px solid transparent;
  cursor: pointer;
  transition: border-color 0.15s, transform 0.15s;
}
.be-swatch:hover {
  transform: scale(1.15);
}
.be-swatch--active {
  border-color: #181818;
  box-shadow: 0 0 0 2px #fff, 0 0 0 4px #181818;
}
.be-preview {
  padding-top: 4px;
}
.be-preview-btn {
  display: inline-block;
  padding: 8px 24px;
  color: #fff;
  border-radius: 6px;
  font-size: 14px;
  font-weight: bold;
  font-family: Arial, Helvetica, sans-serif;
}
</style>
